module.exports = __webpack_public_path__ + "./fonts/app.9906fa74d17b0d47b166267bf076acb8.ttf";